<script>
  import RateCalc from "./Calculator/RateCalc.svelte";
  import Login from "./Account/Login.svelte";
  import Auth from "./Account/Auth.svelte";
  import Profile from "./Account/Profile.svelte";
  import Header from "./Header.svelte";
  import Admin from "./Admin/Admin.svelte";
  import { authState } from "rxfire/auth";
  import { auth, db } from "./firebase";

  let user;
  let loading = true;
  let page = "calc";
  const pages = ['calc', 'profile', 'admin'];
  const params = new URLSearchParams(window.location.search);
  const p = params.get("p");

  if(pages.includes(p)){
    page = p;
  }

  const unsubscribe = authState(auth).subscribe(u => {
    if (u) {
      db.collection("users")
        .doc(u.uid)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            user = doc.data();
            localStorage.setItem("user", JSON.stringify(user));
            loading = false;
          } else {
            console.log("No such document!");
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    } else {
      user = null;
      loading = false;
    }
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
    integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
    crossorigin="anonymous" />
  <script
    src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
    integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo"
    crossorigin="anonymous">

  </script>
  <script
    src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js"
    integrity="sha384-ZMP7rVo3mIykV+2+9J3UJ46jBk0WLaUAdn689aCwoqbBJiSnjAK/l8WvCWPIPm49"
    crossorigin="anonymous">

  </script>
  <script
    src="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js"
    integrity="sha384-ChfqqxuZUCnJSK3+MXmPNIyE6ZbWh2IMqE241rYiqJxyMiZ6OW/JmZQ5stwEULTy"
    crossorigin="anonymous">

  </script>
</svelte:head>
<section>
  {#if user && !loading}
    <Header
      {user}
      {page}
      on:calc={() => (page = 'calc')}
      on:profile={() => (page = 'profile')}
      on:admin={() => (page = 'admin')} />
    {#if page === 'calc'}
      <RateCalc />
    {/if}
    {#if page === 'profile'}
      <Profile />
    {/if}
    {#if page === 'admin'}
      <Admin />
    {/if}
  {:else if !loading}
    <Auth />
  {/if}
</section>
